import axios from "../../utilities/axios";

export const getRelatedVideos = async ({ tags, id }) => {
  const queryString =
    tags.length > 0 ? `tags_like=${tags.join("&tags_like=")}&id_ne=${id}&_limit=5` : `id_ne=${id}&_limit=5`;

  const response = await axios.get(`/videos?${queryString}`);
  return response.data;
};
